import { render, staticRenderFns } from "./chat-img-upload.vue?vue&type=template&id=133360f1&"
import script from "./chat-img-upload.vue?vue&type=script&lang=js&"
export * from "./chat-img-upload.vue?vue&type=script&lang=js&"
import style0 from "./chat-img-upload.vue?vue&type=style&index=0&id=133360f1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports